export type ValidationRule<T> = (value: T) => string | null;

export function runValidationRules<T>(
  value: T,
  rules: ValidationRule<T>[] | undefined,
): string | null {
  if (!rules?.length) return null;
  for (const rule of rules) {
    const message = rule(value);
    if (message) return message;
  }
  return null;
}

export function createRequiredItem(
  message: string,
): ValidationRule<number | null> {
  return (value) => (value == null ? message : null);
}

export function createRequiredString(message: string): ValidationRule<string> {
  return (value) => ((value?.trim() ?? '') === '' ? message : null);
}

export function createMinLengthRule(
  min: number,
  message: string,
): ValidationRule<string> {
  return (value) => ((value?.length ?? 0) < min ? message : null);
}
